import { settled } from 'common/types/Event-type.type';

export const EVENTS_TO_REFETCH_OPPORTUNITIES = [
  settled('OpportunityAdded'),
  settled('OpportunityUpdated'),
  settled('OpportunityDeleted'),
];
